var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"toast-class",class:`${_vm.variant} ${_vm.classAnimation}`},[_c('InfoIcon'),_c('span',[_vm._v(_vm._s(_vm.message))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }